export const SET_GET_DATA_PRODUK = "SET_GET_DATA_PRODUK";
export const SET_SHIFT = "SET_SHIFT";
export const SET_KATEGORY = "SET_KATEGORY";
export const SET_KERANJANG = "SET_KERANJANG";
export const SET_LIST_KATEGORI = "SET_LIST_KATEGORI";
export const SET_ORDER = "SET_ORDER";
export const SET_GET_PAKET = "SET_GET_PAKET";
